import { isArray } from "underscore";

class ResponseMaker {
    data = {};
    data_to_send = {
        data: [],
        shipToAddressId: null
    };

    constructor(data) {
        this.data = data;
    }

    process = () => {
        let d = this.data
        if (d.data && d.data.cartItems && isArray(d.data.cartItems)) {
            d.data.cartItems.map((v, i) => {
                if (v.assetURL) {
                    d.data.cartItems[i].AssetURL = v.assetURL;
                }

                if (v.erpManufacturerCode) {
                    d.data.cartItems[i].ERPManufacturerCode = v.erpManufacturerCode;
                }

                if (v.erpManufacturerName) {
                    d.data.cartItems[i].ERPManufacturerName = v.erpManufacturerName;
                }

                if (v.erpMfrPartNumber) {
                    d.data.cartItems[i].ERPMFRPartNumber = v.erpMfrPartNumber;
                }

                if (v.itemNumber) {
                    d.data.cartItems[i].ItemNumber = v.itemNumber;
                }

                if (v.manufacturerCode) {
                    d.data.cartItems[i].ManufacturerCode = v.manufacturerCode;
                }

                if (v.manufacturerName) {
                    d.data.cartItems[i].ManufacturerName = v.manufacturerName;
                    // d.data.cartItems[i].VariantMFRName = v.manufacturerName;
                }

                if (v.manufacturerPartNumber) {
                    d.data.cartItems[i].ManufacturerPartNumber = v.manufacturerPartNumber;
                }

                if (!v.ShortDescription) {
                    d.data.cartItems[i].ShortDescription = "";
                }

                if (!v.LongDescription) {
                    d.data.cartItems[i].LongDescription = "";
                }
            });
        }
        this.data_to_send = d;
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return this.data_to_send;
    };
}

export default ResponseMaker;